/**
 * 
 */
interface ILoader {
    syncRequest: Promise<any>[]
    asyncRequest: Promise<any>[],
    asyncResponses?: (responses: any) => void
    syncResponses?: (responses: any) => void

}

class RequestUtil {
    /**
     * 
     * @param loader 
     */
    static async loader(loader: ILoader): Promise<void> {
        const { asyncRequest, syncRequest, asyncResponses, syncResponses } = loader

        try {
            for (const asrq of asyncRequest) {
                asrq.then((_response) => {
                    if (asyncResponses) {
                        asyncResponses(_response)
                    }
                })
            }

            if (syncRequest.length > 0) {
                const responses = await Promise.all(syncRequest)
                if (syncResponses) {
                    syncResponses(responses)
                }
            }

        } catch (error) {

        }
    }
}

export { RequestUtil }